import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LoginForm } from '@/components/login-form';
import { getErrorMessage } from '@/utils/error-codes';
import {toast} from "@sakura-grp/ui/sonner";

/**
 * エラーパラメータに基づいてトーストを表示
 */
const showErrorToast = (errorParam: string) => {
  // トーストIDを使用して同じエラーの重複表示を防ぐ
  const toastId = `error-${errorParam}`;

  if (errorParam === 'unauthorized') {
    toast.error('アクセス権限がありません', {
      id: toastId,
      description: 'ホステスとして登録されていないため、アクセスできません。',
      duration: 5000,
    });
    return;
  }

  const errorMessage = getErrorMessage(Number(errorParam));
  if (errorMessage) {
    toast.error('エラーが発生しました', {
      id: toastId,
      description: errorMessage,
      duration: 5000,
    });
  }
};

/**
 * ログインページ
 *
 * URLパラメータ:
 * - error: エラーコード (数値) または 'unauthorized'
 */
export default function SignIn() {
  const [searchParams, setSearchParams] = useSearchParams();
  const errorParam = searchParams.get('error');

  useEffect(() => {
    if (!errorParam) return;

    // エラーを取得したら即座にURLパラメータをクリア（履歴を汚さない）
    const error = errorParam;
    setSearchParams({}, { replace: true });

    // トースト表示
    showErrorToast(error);
  }, [errorParam, setSearchParams]);

  return (
    <div className="relative flex min-h-screen items-center justify-center p-4 pt-safe pb-safe bg-gradient-to-br from-stone-900 via-stone-800 to-stone-900">
      <div className="pointer-events-none absolute inset-0 opacity-[0.03]" style={{backgroundImage: "url('data:image/svg+xml,%3Csvg viewBox=%220 0 256 256%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noise%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.65%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noise)%22/%3E%3C/svg%3E')"}} />
      <div className="relative z-10 w-full max-w-(--container-xs) animate-fade-in-scale">
        <LoginForm />
      </div>
    </div>
  );
}
